// import React, { useEffect, useState } from "react"
// import { MDBDataTable } from "mdbreact"
// import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

// import { connect } from "react-redux";

// //Import Action to copy breadcrumb items from local state to redux state
// import { setBreadcrumbItems } from "../../store/actions";


// import { useDispatch } from "react-redux";
// import { Modal } from "react-bootstrap";
// import Loader from "components/Loader/Loader";
// import { deleteUserType, getAllUserTypes, updateUserType } from "helpers/userTypeHelper";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { UPDATE_USER_TYPE } from "helpers/url_helper";

// const AllUserTypes = (props) => {
//     document.title = "Question Bank | All User Types";
//     const [modalShow, setModalShow] = useState(false);
//     const [name, setName] = useState("");
//     const [permissions, setPermissions] = useState([]);
//     const [allUserTypes, setAllUserTypes] = useState([]);
//     const [spanDisplay, setSpanDisplay] = useState("none");
//     const [loader, setLoader] = useState(false);
//     const [id, setId] = useState({});
//     const [contentAccess, setContentAccess] = useState(false);
//     const [trainerAccess, setTrainerAccess] = useState(false);
//     const [deleteModalShow, setDeleteModalShow] = useState(false);
//     const dispatch = useDispatch();


//     const breadcrumbItems = [
//         { title: "User Type", link: "#" },
//         { title: "All User Types", link: "#" },
//     ]


//     useEffect(() => {
//         props.setBreadcrumbItems('All User Types', breadcrumbItems)


//     })

//     useEffect(() => {           /* For closing the sidebar if opened */
//         const blurDiv = document.getElementById("blur");
//         var width = window.innerWidth;
//         if (width <= 994) {
//             blurDiv.click()
//         }
//     }, [])



//     useEffect(() => {
//         fetchUserTypes();
//     }, [])

//     const fetchUserTypes = async () => {
//         try {

//             const result = await getAllUserTypes();
//             setAllUserTypes(result?.result);
//         } catch (error) {
//             toast.error(error?.responsive?.data?.message);
//         }
//     }


//     const data = {
//         columns: [
//             {
//                 label: "Serial No.",
//                 field: "serialNo",
//                 sort: "asc",
//                 width: 50,
//             },
//             {
//                 label: "Name",
//                 field: "name",
//                 sort: "asc",
//                 width: 100,
//             },
//         ],
//         rows: allUserTypes,
//         rows: allUserTypes?.map((row, index) => ({
//             ...row,
//             serialNo: index + 1, // Add 1 to start counting from 1
//             clickEvent: () => handleRowClick(row)
//         }))
//     }

//     const handleRowClick = (row) => {


//         console.log(row)
//         setName(row?.name);
//         setContentAccess(row?.permissions?.contentAccess);
//         setTrainerAccess(row?.permissions?.trainerAccess);
//         setModalShow(true);
//         setId(row?.id);



//     }





//     const handleDelete = async () => {
//         try {
//             setLoader(true);
//             const data = await deleteUserType(id);
//             setDeleteModalShow(false);
//             setLoader(false);
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setModalShow(false);
//                 fetchUserTypes();
//             }
//             else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             setLoader(false);
//             console.log(error);
//             toast.error(error?.responsive?.data?.message)
//         }
//     };



//     const handleContentRights = (e) => { contentAccess === false ? setContentAccess(true) : setContentAccess(false) }
//     const handleTrainerRights = (e) => { trainerAccess === false ? setTrainerAccess(true) : setTrainerAccess(false) }


//     const handleUpdate = async () => {
//         try {
//             setLoader(true);
//             const permissions = { contentAccess, trainerAccess }
//             const data = await updateUserType({ id, name, permissions });
//             if (data?.success) {
//                 toast.success(data?.message);
//                 setName("");
//                 setContentAccess(false);
//                 setTrainerAccess(false);
//                 setModalShow(false)
//                 fetchUserTypes();
//             }
//             else {
//                 toast.error(data?.message);
//             }
//         } catch (error) {
//             toast.error(error?.responsive?.data?.message)
//         } finally {
//             setLoader(false);
//         }
//     }
//     return (
//         <React.Fragment>
//             {loader ? (
//                 <Loader />
//             ) : ("")}
//             <Row>
//                 <Col className="col-12">
//                     <Card>
//                         <CardBody>
//                             <CardTitle className="h4">All User Types</CardTitle>
//                             <MDBDataTable className="table-row-hover" responsive bordered data={data} style={{ cursor: 'pointer' }} noBottomColumns />
//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>

//             <Modal
//                 show={modalShow}
//                 size="lg"
//                 aria-labelledby="contained-modal-title-vcenter"
//                 centered
//             >
//                 <Modal.Header >
//                     <Modal.Title id="contained-modal-title-vcenter">
//                         Edit User
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>


//                     <Row className="mb-3">
//                         <label
//                             htmlFor="example-text-input"
//                             className="col-md-2 col-form-label"
//                         >
//                             Name
//                         </label>
//                         <div className="col-md-10">
//                             <input type="text"
//                                 className='form-control'
//                                 placeholder="Enter User Name"
//                                 value={name}
//                                 onChange={(e) => setName(e.target.value)} />
//                             {!name && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}

//                         </div>
//                     </Row>
//                     <Row className="mb-3">

//                         <div className="d-flex flex-wrap">
//                             <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
//                                 <label htmlFor="class_access" className="col-md-6 col-form-label">
//                                     Content Managment
//                                 </label>
//                                 <div className="mt-2">
//                                     <input
//                                         type="checkbox"
//                                         id="class_access"
//                                         name="class_access"
//                                         value={1}
//                                         onChange={handleContentRights}
//                                         checked={contentAccess ? 'checked' : ''}
//                                     />
//                                 </div>
//                             </div>

//                             <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
//                                 <label htmlFor="class_access" className="col-md-6 col-form-label">
//                                     Trainer Managment
//                                 </label>
//                                 <div className="mt-2">
//                                     <input
//                                         type="checkbox"
//                                         id="class_access"
//                                         name="class_access"
//                                         value={1}
//                                         onChange={handleTrainerRights}
//                                         checked={trainerAccess ? 'checked' : ''}
//                                     />
//                                 </div>
//                             </div>
//                         </div>

//                     </Row>



//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => setModalShow(false)} className="waves-effect waves-light">Close</Button>{" "}
//                     <Button type="button" color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false) }} className="waves-effect waves-light">Delete</Button>{" "}
//                     <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
//                     {/* <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Delete</Button>{" "} */}
//                 </Modal.Footer>
//             </Modal>

//             <Modal
//                 show={deleteModalShow}
//                 size="lg"
//                 aria-labelledby="contained-modal-title-vcenter"
//                 centered
//             >
//                 <Modal.Body>

//                     <h4>
//                         Are you sure want to remove this user type.
//                     </h4>


//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button type="button" color="primary" onClick={() => { setDeleteModalShow(false); setModalShow(true) }} className="waves-effect waves-light">No</Button>{" "}
//                     <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Yes</Button>{" "}

//                 </Modal.Footer>
//             </Modal>

//         </React.Fragment>
//     )
// }

// export default connect(null, { setBreadcrumbItems })(AllUserTypes);











import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap"
import { connect } from "react-redux";
import Select from "react-select"
import { Modal } from "react-bootstrap";
import { deleteUser, fetchAllUsers, updateUser } from "helpers/user_helper";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { setBreadcrumbItems } from "store/actions";
import { getAllUserTypes } from "helpers/userTypeHelper";

const AllUsers = (props) => {
    document.title = "Question Bank | All Users";
    const [modalShow, setModalShow] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [type, setType] = useState({});
    const [depot, setDepot] = useState({});
    const [allUserTypes, setAllUserTypes] = useState([]);
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const [id, setId] = useState(null);
    const [users, setUsers] = useState([]);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [isDepotManager, setIsDepotManager] = useState(false);
    const [currentDepotName, setCurrentDepotName] = useState("");

    const breadcrumbItems = [
        { title: "User", link: "#" },
        { title: "All Users", link: "#" },
    ]

    const depotData = [
        { id: 1, name: "BBM" },
        { id: 2, name: "Backbay" },
        { id: 3, name: "Bawana" },
        { id: 4, name: "Bhagwati Nagar" },
        { id: 5, name: "Deepanjali Nagar" },
        { id: 6, name: "Dichaon Kalan" },
        { id: 7, name: "Dwarka-8" },
        { id: 8, name: "GTK" },
        { id: 9, name: "Hari Nagar-2" },
        { id: 10, name: "Hasanpur" },
        { id: 11, name: "Hennur" },
        { id: 12, name: "Indraprastha" },
        { id: 13, name: "Jayanagar" },
        { id: 14, name: "Jigani" },
        { id: 15, name: "K R Puram" },
        { id: 16, name: "Kalkaji" },
        { id: 17, name: "Kalinga Nagar" },
        { id: 18, name: "Kannalli" },
        { id: 19, name: "Malwani" },
        { id: 20, name: "Mayapuri" },
        { id: 21, name: "Mera Mandali" },
        { id: 22, name: "Mundela Kalan" },
        { id: 23, name: "Nand Nagri" },
        { id: 24, name: "Narela" },
        { id: 25, name: "Naraina" },
        { id: 26, name: "Naranpura" },
        { id: 27, name: "Nehru Place" },
        { id: 28, name: "Okhla" },
        { id: 29, name: "Online" },
        { id: 30, name: "Pantnagar" },
        { id: 31, name: "Pantha Chowk" },
        { id: 32, name: "Peenya" },
        { id: 33, name: "Rohini-1" },
        { id: 34, name: "Rohini-2" },
        { id: 35, name: "Sarojini Nagar" },
        { id: 36, name: "Shanti Nagar" },
        { id: 37, name: "Shivaji Nagar" },
        { id: 38, name: "Subhash Place" },
        { id: 39, name: "Sukhdev Vihar" },
        { id: 40, name: "Tekhand" },
        { id: 41, name: "Tss" },
        { id: 42, name: "Wazirpur" },
        { id: 43, name: "Worli" },
        {id:44, name: "Traffic Management Centre (TMC)"},
        {id:45, name:"Vaddarahalli"}

    ];

    useEffect(() => {
        props.setBreadcrumbItems('All Users', breadcrumbItems)
    }, [])

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        fetchUserTypes();
        fetchUsers();
    }, [])

    const fetchUsers = async () => {
        try {
            setLoader(true);
            const data = await fetchAllUsers();
            console.log("Fetched users data:", data); // Debug log
            setUsers(data?.result);
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }
    }

    const fetchUserTypes = async () => {
        try {
            const result = await getAllUserTypes();
            setAllUserTypes(result?.result);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const data = {
        columns: [
            {
                label: "Serial No.",
                field: "serialNo",
                sort: "asc",
                width: 50,
            },
            {
                label: "Name",
                field: "name",
                sort: "asc",
                width: 100,
            },
            {
                label: "Email",
                field: "email",
                sort: "asc",
                width: 150,
            },
            {
                label: "Phone Number",
                field: "mobile",
                sort: "asc",
                width: 200,
            },
            {
                label: "User Type",
                field: "userType",
                sort: "asc",
                width: 150,
            },
            {
                label: "Depot",
                field: "depot",
                sort: "asc",
                width: 150,
            },
        ],
        rows: users?.map((row, index) => {
            // Debug log to see the structure
            console.log("Row data:", row);
            
            // Get depot name from various possible locations
            let depotName = "N/A";
            if (row?.tataUserDetailsDto?.depot) {
                depotName = row.tataUserDetailsDto.depot;
            } else if (row?.tataUserDetails?.depot) {
                depotName = row.tataUserDetails.depot;
            } else if (row?.depot) {
                depotName = row.depot;
            }
            
            return {
                ...row,
                serialNo: index + 1,
                userType: row?.userTypeDto?.name || row?.userType?.name || "N/A",
                depot: depotName,
                clickEvent: () => handleRowClick(row)
            };
        })
    }

    const handleRowClick = (row) => {
        console.log("Selected row:", row); // Debug log
        
        setModalShow(true);
        setId(row?.id);
        setEmail(row?.email);
        setName(row?.name);
        setMobile(row?.mobile);
        
        // Find and set user type
        const userTypeName = row?.userTypeDto?.name || row?.userType?.name;
        const selectedType = allUserTypes.find(d => d.name === userTypeName);
        console.log("Selected type:", selectedType); // Debug log
        setType(selectedType || {});
        
        // Check if user is Depot Manager
        if (userTypeName === "Tata Depot Manager") {
            setIsDepotManager(true);
            
            // Get the depot name from various possible locations
            let depotName = "";
            if (row?.tataUserDetailsDto?.depot) {
                depotName = row.tataUserDetailsDto.depot;
            } else if (row?.tataUserDetails?.depot) {
                depotName = row.tataUserDetails.depot;
            } else if (row?.depot) {
                depotName = row.depot;
            }
            
            console.log("Depot name found:", depotName); // Debug log
            
            // Set current depot name for display
            setCurrentDepotName(depotName || "");
            
            // Find and set the depot object from depotData
            if (depotName) {
                const depotObj = depotData.find(d => d.name === depotName);
                console.log("Found depot object:", depotObj); // Debug log
                setDepot(depotObj || {});
            } else {
                setDepot({});
            }
        } else {
            setIsDepotManager(false);
            setDepot({});
            setCurrentDepotName("");
        }
        
        // Reset span display
        setSpanDisplay("none");
    }

    const handleUpdate = async () => {
        if (!name || !email || !type || !mobile) {
            setSpanDisplay("inline")
            toast.error("Please fill all required fields");
            return;
        }

        // Validate mobile number
        const mobileRegex = /^\d{10}$/;
        if (!mobileRegex.test(mobile)) {
            toast.error("Please enter a valid mobile number (10 digits).");
            return;
        }

        // Validate depot for Depot Manager
        if (type?.name === "Tata Depot Manager" && !depot?.name) {
            toast.error("Please select a depot");
            setSpanDisplay("inline");
            return;
        }

        try {
            let userTypeDto = type;
            setLoader(true);
            
            // Prepare update data
            const updateData = {
                id,
                name,
                email,
                mobile,
                userTypeDto
            };

            // Add depot details if user is Tata Depot Manager
            if (type?.name === "Tata Depot Manager" && depot?.name) {
                updateData.tataUserDetailsDto = { depot: depot.name };
                console.log("Updating depot to:", depot.name); // Debug log
            }

            console.log("Update data:", updateData); // Debug log

            const data = await updateUser(updateData);
            setLoader(false);
            
            if (data?.success) {
                setModalShow(false);
                toast.success(data?.message);
                // Reset form
                resetForm();
                // Refresh users list
                fetchUsers();
            } else {
                toast.error(data?.message || "Failed to update user");
            }
        } catch (error) {
            setLoader(false);
            console.error("Update error:", error);
            toast.error(error?.response?.data?.message || "An error occurred while updating");
        }
    }

    const handleDelete = async () => {
        try {
            setLoader(true);
            const data = await deleteUser(id);
            setDeleteModalShow(false);
            setLoader(false);
            if (data?.success) {
                toast.success(data?.message);
                setModalShow(false);
                resetForm();
                fetchUsers();
            } else {
                toast.error(data?.message || "Failed to delete user");
            }
        } catch (error) {
            setLoader(false);
            console.error("Delete error:", error);
            toast.error(error?.response?.data?.message || "An error occurred while deleting");
        }
    }

    const handleSelectType = (selectedValue) => {
        console.log("Selected type:", selectedValue); // Debug log
        setType(selectedValue);
        
        // Reset depot if user type is not Tata Depot Manager
        if (selectedValue?.name !== "Tata Depot Manager") {
            setDepot({});
            setIsDepotManager(false);
            setCurrentDepotName("");
        } else {
            setIsDepotManager(true);
        }
    }

    const handleSelectDepot = (selectedValue) => {
        console.log("Selected depot:", selectedValue); // Debug log
        setDepot(selectedValue);
    }

    const resetForm = () => {
        setName("");
        setEmail("");
        setMobile("");
        setType({});
        setDepot({});
        setId(null);
        setIsDepotManager(false);
        setCurrentDepotName("");
        setSpanDisplay("none");
    }

    return (
        <React.Fragment>
            {loader && <Loader />}
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4">All Users</CardTitle>
                            <MDBDataTable 
                                className="table-row-hover" 
                                responsive 
                                bordered 
                                data={data} 
                                style={{ cursor: 'pointer' }} 
                                noBottomColumns 
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Edit User Modal */}
            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => {
                    setModalShow(false);
                    resetForm();
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit User
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <label
                            htmlFor="edit-name"
                            className="col-md-2 col-form-label"
                        >
                            Name <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-10">
                            <input 
                                type="text"
                                id="edit-name"
                                className='form-control'
                                placeholder="Enter User Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)} 
                            />
                            {!name && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="edit-email"
                            className="col-md-2 col-form-label"
                        >
                            Email <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-10">
                            <input 
                                type="email"
                                id="edit-email"
                                className='form-control'
                                placeholder="Enter Email Id"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)} 
                            />
                            {!email && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="edit-mobile"
                            className="col-md-2 col-form-label"
                        >
                            Phone Number <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-10">
                            <input 
                                type="text"
                                id="edit-mobile"
                                className='form-control'
                                placeholder="Enter Phone Number"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)} 
                            />
                            {!mobile && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="edit-user-type"
                            className="col-md-2 col-form-label"
                        >
                            User Type <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-10">
                            <Select
                                id="edit-user-type"
                                value={type}
                                onChange={handleSelectType}
                                options={allUserTypes}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id}
                                classNamePrefix="select2-selection"
                                placeholder="Select User Type"
                            />
                            {!type?.name && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    {/* Depot selection - only shown for Tata Depot Manager */}
                    {isDepotManager && (
                        <Row className="mb-3">
                            <label
                                htmlFor="edit-depot"
                                className="col-md-2 col-form-label"
                            >
                                Depot <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-10">
                                <Select
                                    id="edit-depot"
                                    value={depot}
                                    onChange={handleSelectDepot}
                                    options={depotData}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option.id}
                                    classNamePrefix="select2-selection"
                                    placeholder="Select Depot"
                                />
                                {/* Show current depot name */}
                                {currentDepotName && (
                                    <div style={{ 
                                        marginTop: '8px', 
                                        padding: '8px 12px', 
                                        backgroundColor: '#e8f4fd', 
                                        borderRadius: '4px',
                                        borderLeft: '3px solid #0d6efd'
                                    }}>
                                        <small className="text-dark">
                                            <strong>Current Depot:</strong> {currentDepotName}
                                        </small>
                                    </div>
                                )}
                                {!depot?.name && <span style={{ color: "red", display: spanDisplay, marginTop: '5px' }}>This field is required</span>}
                            </div>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        type="button" 
                        color="secondary" 
                        onClick={() => {
                            setModalShow(false);
                            resetForm();
                        }} 
                        className="waves-effect waves-light"
                    >
                        Close
                    </Button>
                    <Button 
                        type="button" 
                        color="danger" 
                        onClick={() => {
                            setDeleteModalShow(true);
                            setModalShow(false);
                        }} 
                        className="waves-effect waves-light"
                    >
                        Delete
                    </Button>
                    <Button 
                        type="button" 
                        color="success" 
                        onClick={handleUpdate} 
                        className="waves-effect waves-light"
                        disabled={loader}
                    >
                        {loader ? 'Updating...' : 'Update'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal
                show={deleteModalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => {
                    setDeleteModalShow(false);
                    setModalShow(true);
                }}
            >
                <Modal.Body>
                    <h4>Are you sure you want to delete this user?</h4>
                    <p className="text-muted">This action cannot be undone.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        type="button" 
                        color="primary" 
                        onClick={() => {
                            setDeleteModalShow(false);
                            setModalShow(true);
                        }} 
                        className="waves-effect waves-light"
                    >
                        No
                    </Button>
                    <Button 
                        type="button" 
                        color="danger" 
                        onClick={handleDelete} 
                        className="waves-effect waves-light"
                        disabled={loader}
                    >
                        {loader ? 'Deleting...' : 'Yes'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(AllUsers);